<template>
	<div class="page-container">
        <e-nav :type="0"></e-nav>
        <div v-for="(section, title) in keys" :key="title" class="list-section" >
            <div class="list-section-title">{{section}}</div>
            <div class="list-container">
                <div v-for="(item, index) in listData[section]" :key="index" class="list-cell">
                    <div v-lazy-container="{selector: 'img'}" :class="item.isAward == 1 ? 'cup' : '' ">
                        <div class="img"><img :data-src="item.coverUrl ? item.coverUrl : defUrl" :data-error="defUrl" class="list-img"/></div>
                        <div class="list-info">
                            <span class="name" v-if="item.name">{{item.name}}</span>
                            <span v-if="item.performer">表演者:{{item.performer}}</span>
                            <span v-if="item.product_party">出品方:{{item.product_party}}</span>
                            <span v-if="item.producer">制作人:{{item.producer}}</span>
                            <span v-if="item.entityIssuer">实体发行方:{{item.entityIssuer}}</span>
                            <span v-if="item.platform_issuer">发行方:{{item.platform_issuer}}</span>
                            <span v-if="item.lyricist">作词人:{{item.lyricist}}</span>
                            <span v-if="item.composer">作曲人:{{item.composer}}</span>
                            <span v-if="item.arranger">编曲人:{{item.arranger}}</span>
                            <span v-if="item.recordings">录音师:{{item.recordings}}</span>
                            <span v-if="item.recording_room">录音室:{{item.recording_room}}</span>
                            <span v-if="item.beats_mixr">混音师:{{item.beats_mixr}}</span>
                            <span v-if="item.mixing_studio">混音室:{{item.mixing_studio}}</span>
                            <span v-if="item.cover_designer">封面视觉设计者:{{item.cover_designer}}</span>
                            <span v-if="item.director_mv">MV导演:{{item.director_mv}}</span>
                        </div>
                    </div>
                </div>
            </div>
        </div> 
        <div class="tips">注：各奖项提名按照拼音字母顺序排序。CMA2019入围提名是由全体唱工委会员一家一个投票权集体投票得出。该入围提名的投票及合规经会计师事务所普华永道（PwC）作为独立第三方机构，全程执行协定程序。</div>
	</div>
</template>

<script>
import eNav from '@/components/Nav'   
export default {
	name: 'finalist',
    components: {
        eNav
    },
	data () { 
		return {
            listData: {},
            keys:[],
            defUrl: 'http://img01.cmicawards.org.cn/cover/CMADefault.jpg'
		}
	},
	mounted: function() {
        this.getList()
    },
	methods:{
        getList(){
            this.$axios.get('/user/getShortlist', {
                params: {}
            }).then(response => {
                const {code, data, message, total} = response.data
                if(code !== 0) return this.$message.error(message);
                this.listData = data

                this.keys = Object.keys( this.listData )

            }, function() {
                
            })
        }
    }
}
</script>
<style lang="scss" scoped>
	.list-section {
		padding: 20px 0;

		.list-section-title {
			font-size: 24px;
            color: #181413;
			line-height: 24px;
		}

		.list-container {
            margin-top: 10px;
            overflow: hidden;

            .list-cell {
                float: left;
                margin-top: 20px;
                width: 50%;

                &> div{
                    margin-right: 20px;
                    overflow: hidden;
                    background-color: #FBFCFE;
                    position: relative;
                    &.cup{
                        background:url('../assets/images/cup_1.png')  #FBFCFE 96% 10% no-repeat;
                    }
                    .img{
                        /*弹性盒模型*/    
                        display:flex;
                        /*主轴居中对齐*/
                        justify-content: center;
                        /*侧轴居中对齐*/    
                        align-items: center; 
                        width: 250px;
                        height: 250px;
                        float: left;
                        text-align: center;
                        background-color: #000;
                        .list-img {
                            max-width: 100%;
                            max-height: 100%;
                        }
                    }
                    .list-info {
                        margin: 0 20px 0 270px;
                        padding: 15px 0;
                        overflow: hidden;

                        span {
                            display: block;
                            font-size: 12px;
                            color: #AAAAAA;
                            line-height: 24px;
                            // overflow: hidden;
                            // text-overflow: ellipsis;
                            // white-space: nowrap;

                            &.name {
                                padding-bottom: 15px;
                                font-size: 24px;
                                color: #AF804D;
                                line-height: 28px;
                                overflow: visible;
                                text-overflow: ellipsis;
                                white-space: normal;
                            }
                        }
                    } 

                }

            }
		}
	}

    .tips{
        color: #AF804D;
        margin: 20px 0;
        line-height: 24px;
        font-size: 14px;
    }
</style>

